<div class="dialog-content-wrapper" fusePerfectScrollbar>
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <span i18n class="title dialog-title">Назначьте соответствие материалам изделия</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-0 pb-0 m-0" fusePerfectScrollbar>
    <ng-container>
      <div class="px-6 py-4" *ngIf="products.length > 1">
        <mat-checkbox i18n [(ngModel)]="matGroupingCheckbox">Группировать по материалу</mat-checkbox>
      </div>

      <mat-divider *ngIf="products.length > 1"></mat-divider>

      <ng-container *ngIf="products.length === 1 || matGroupingCheckbox; else multiModelTemplate">
        <cutting-cadmodel-materials-matching [cadModelMaterialLink]="getCommonMaterialLinks(products)">
        </cutting-cadmodel-materials-matching>
      </ng-container>

      <ng-template #multiModelTemplate>
        <mat-tab-group>
          <mat-tab label="{{ item.name }}" *ngFor="let item of products">
            <cutting-cadmodel-materials-matching [cadModelMaterialLink]="item.parsedMaterials">
            </cutting-cadmodel-materials-matching>
          </mat-tab>
        </mat-tab-group>
      </ng-template>
    </ng-container>
  </div>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
    <button i18n mat-raised-button class="mat-accent mr-4" (click)="saveAndClose()">ОК</button>
    <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
  </div>
</div>
